<!--
 * @Author: Zyr
 * @Date: 2021-01-07 17:43:53
 * @LastEditTime: 2021-01-11 10:39:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lwdgis-ui-master\src\components\Account\comMainInfo.vue
-->

<template>
    <div class="card-fa-div">
        <el-card class="box-card" style="width: 100%; height:150px;">
            <el-row>
                <h1 style="float:left">积分明细</h1>
            </el-row>   
            <el-row>
                <el-tabs v-model="activePart" @tab-click="handleClick" style="padding-left:20px">
                    <el-tab-pane label="可兑换积分" name="point_available">
                        
                    </el-tab-pane>
                    <el-tab-pane label="积分使用" name="point_used">积分使用</el-tab-pane> 
                </el-tabs>
            </el-row>   
        </el-card>
        <el-card class="box-card" style="width: 100%; height:590px;" v-if="is_point_convertible">
            <el-row>
                <div class="border-box" style="height:60px;">
                    <span style="font-size:26px;font-weight:500;color:red;">我的积分&nbsp;&nbsp;{{current_point}}</span>
                    <span style="float: right;">温馨提示：您进行操作获得的积分，在通过审核后，会于三天内到账</span>
                </div>
            </el-row>
            <el-row>
                <div class="border-box" style="margin-top:20px">
                    <el-table 
                        :data="point_convertible">
                        <el-table-column prop="type" label="积分类型"></el-table-column>
                        <el-table-column prop="num" label="积分值"></el-table-column>
                        <el-table-column prop="date" label="到账日期"></el-table-column>
                    </el-table>
                </div>
            </el-row>
        </el-card>
        <el-card class="box-card" style="width: 100%; height:590px;" v-if="is_point_used">
            
            <el-row>
                <div class="border-box" >
                    <el-table 
                        :data="point_used">
                        <el-table-column prop="type" label="积分类型"></el-table-column>
                        <el-table-column prop="num" label="积分值"></el-table-column>
                        <el-table-column prop="date" label="到账日期"></el-table-column>
                    </el-table>
                </div>
            </el-row>
        </el-card>
    </div>
</template>

<script>


export default {
    name:'comMainInfo',
    data(){
      return{
        activePart:'point_available',
        // 当前积分
        current_point:0,
        // 可兑换积分表格
        point_convertible:[{
            type: '添加定位',
            num: '+10',
            date: '2021-01-01'
          },{
            type: '修改定位',
            num: '+10',
            date: '2021-01-03'
          },{
            type: '修改定位',
            num: '+10',
            date: '2021-01-05'
          },{
            type: '添加定位',
            num: '+10',
            date: '2021-01-10'
          },],
          // 已兑换积分表格
          point_used:[{
            type: '添加定位',
            num: '+10',
            date: '2021-01-01'
          },{
            type: '修改定位',
            num: '+10',
            date: '2021-01-03'
          },{
            type: '修改定位',
            num: '+10',
            date: '2021-01-05'
          },{
            type: '添加定位',
            num: '+10',
            date: '2021-01-10'
          },],

          is_point_convertible:true,
          is_point_used:false

       
                    
      }
    },

  components: {
    
  },

    mounted(){
      
    },

    methods:{

        
        handleClick(val){
            if(val.label == '可兑换积分')
            {
                this.is_point_convertible = true
                this.is_point_used = false
            }
            else if (val.label == '积分使用')
            {
                this.is_point_convertible = false
                this.is_point_used = true
            }
        }

    }

}
</script>
<style src = '../../css/comm_page.css'></style>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Account/comPointInfo.vue